exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".buttons {\n  margin-top: 20px;\n  float: right; }\n\nmd-select {\n  margin-top: 15px; }\n\n.mat-radio-group {\n  margin-top: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .mat-radio-group md-radio-button {\n    margin-left: 15px; }\n\ninput {\n  color: black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/my-organisation/components/edit-company/edit-company-quota.component.scss
// module id = 1268
// module chunks = 0